import { ReactNode } from "react";
import { Box } from "@mui/material";

interface IChartContainerProps {
  children: ReactNode;
  height?: number;
}

// Contenedor de altura fija y position relative requerido por los charts de
// Chart.js con `maintainAspectRatio: false`: sin una altura acotada el canvas
// responsive puede crecer indefinidamente (loop de resize) y da alturas
// inconsistentes entre secciones.
const ChartContainer = ({ children, height = 260 }: IChartContainerProps) => (
  <Box sx={{ position: "relative", height, width: "100%" }}>{children}</Box>
);

export default ChartContainer;
